<template>
    <v-container @keyup.enter="submit" fill-height :style="{width: $vuetify.breakpoint.smAndDown ? '90%' : '50%'}">
        <v-col>
            <h1 class="display-1">GATEBRAINS</h1>
            <div class="elevation-10 pa-3">
                <v-form ref="form">
                    <v-text-field v-model="username" label="Brukernavn" type="email" required :rules="usernameRules"></v-text-field>
                    <v-text-field v-model="password" label="Passord" :type="showPassword? 'text': 'password'" required :append-icon="showPassword? 'mdi-eye-off': 'mdi-eye'" @click:append="toggleShowPassword" :rules="passwordRules"></v-text-field>
                    <v-text-field v-model="project" label="Prosjekt" type="text" required :rules="projectRules"></v-text-field>
                    <v-row justify="center">
                        <v-btn @click="revertToLocalstorage" class="mx-1">nullstill</v-btn>
                        <v-btn @click="submit" color="info" class="mx-1">
                            <span v-if="!loginStarted">login</span>
                            <v-progress-circular v-if="loginStarted" indeterminate color="white" size=24></v-progress-circular>
                        </v-btn>
                    </v-row>

                </v-form>

                <br>

                <v-row justify="center">
                    <v-tooltip bottom>
                        <template v-slot:activator="{on}">
                            <v-btn v-on="on" @click="showResetPassword" text class="caption">Nullstill passord</v-btn>
                        </template>
                        <span>Om e-postadressen er registrert vil du få en e-post.</span>
                    </v-tooltip>
                </v-row>

            </div>
        </v-col>

        <v-snackbar v-model="snackbar.show" :color="snackbar.color" bottom right>
            {{snackbar.text}}
        </v-snackbar>

        <v-dialog v-model="showResetDialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Nullstill passord</v-card-title>
                <v-card-text>
                    <v-form ref="resetPasswordForm">
                        <v-text-field v-model="resetUsername" label="Brukernavn" type="email" required :rules="usernameRules"></v-text-field>
                        <v-text-field v-model="resetProject" label="Prosjekt" type="text" required :rules="projectRules"></v-text-field>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="cancelResetPassword">avbryt</v-btn>
                    <v-btn @click="resetPassword" color="primary">nullstill</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>

</template>

<script>
export default {
    data() {
        return {
            valid: true,
            username: "",
            usernameRules: [
                v => !!v || "Burkernavn er påkrevd",
                v =>
                    (!!v && /.+@.+\..+/.test(v)) ||
                    "Brukernavn må være en e-post adresse"
            ],
            password: "",
            showPassword: false,
            passwordRules: [
                v => (!!v && v.length >= 3) || "Passord må være mer enn 3 tegn"
            ],
            projectRules: [v => !!v || "Prosjekt er påkrevd"],
            project: "",
            loginStarted: false,
            showResetDialog: false,
            resetUsername: "",
            resetProject: "",
            snackbar: {
                color: "info",
                show: false,
                text: ""
            }
        };
    },
    methods: {
        toggleShowPassword() {
            this.$set(this, "showPassword", !this.showPassword);
            // this.showPassword = !this.showPassword
        },
        cancelResetPassword: function() {
            this.$refs.resetPasswordForm.reset();
            this.showResetDialog = false;
            this.cancel();
        },
        showResetPassword: function() {
            this.showResetDialog = true;
        },
        resetPassword: function() {
            if (this.$refs.resetPasswordForm.validate()) {
                // send reset to backend...
                this.axios.defaults.baseURL = process.env.VUE_APP_API;
                this.axios
                    .post(
                        // `${process.env.VUE_APP_API}/user/reset`,
                        `/user/reset`,
                        {
                            username: this.resetUsername
                        },
                        {
                            params: {
                                project: this.resetProject
                            }
                        }
                    )
                    .then(response => {
                        if (response.data.success) {
                            this.snackbar.color = "info";
                            this.snackbar.text = `passordet er nullstilt: ${this.resetUsername}`;
                            this.snackbar.show = true;

                            this.cancelResetPassword();
                        } else {
                            throw new Error();
                        }
                    })
                    .catch(() => {
                        this.snackbar.color = "error";
                        this.snackbar.text = "passord ikke nullstilt";
                        this.snackbar.show = true;
                    });

                this.cancel();
            }
        },
        submit: function() {
            if (this.$refs.form.validate()) {
                // axios.defaults.baseURL = `http://${this.project}.proxylock.com:8088/`;
                // axios.defaults.baseURL = `http://${
                //     this.project
                // }.localhost:8088/`;
                // axios.defaults.baseURL = `http://${this.project}.192.168.10.133:8088/`;

                this.axios.defaults.baseURL = process.env.VUE_APP_API;
                this.axios.defaults.params = {};
                // axios.defaults.params["project"] = this.project;

                this.loginStarted = true;

                localStorage.setItem("username", this.username);
                localStorage.setItem("project", this.project);

                // axios.defaults.baseURL = process.env.VUE_APP_API.replace('#', this.project);
                // console.log(
                //     `Login.vue -> url = ${this.axios.defaults.baseURL}`
                // );
                this.$store
                    .dispatch("login", {
                        username: this.username,
                        password: this.password,
                        project: this.project
                    })
                    .then(result => {
                        if (result.success) {
                            this.axios.defaults.params = {};
                            this.axios.defaults.params["project"] =
                                result.project;
                            // console.log(`project = ${result.project}`);

                            localStorage.setItem("project", result.project);

                            this.loginStarted = false;
                            this.$router.push("/dashboard");
                        } else {
                            this.loginStarted = false;
                            // console.log(result.message);
                        }
                    });
            }
        },
        cancel: function() {
            this.$refs.form.reset();
        },
        revertToLocalstorage: function() {
            if (localStorage.getItem("username")) {
                this.username = localStorage.getItem("username");
            }

            if (localStorage.getItem("project")) {
                this.project = localStorage.getItem("project");
            }
        }
    },
    mounted: function() {
        this.revertToLocalstorage();
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", false);
            vue.$store.commit("showNavDrawer", false);
        });
    },
};
</script>

<style scoped>
/* v-flex {
    align-items: center;
    justify-content: center;
} */
</style>
